// @flow strict

// Note there is a potential bug / race condition with this component -
// if the user expands the form before the iframe messaging code has grabbed the
// iframe height from the iframe, the expander will not expand to the correct height
// (usually it won't expand at all)
// Usually this form is located low down on the page so it's not high priority
// TODO fix this bug

import * as React from 'react';
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import { Button } from '../../internal/Button';
import Iframe from '../Iframe';
import ExpanderAnimation from '../../internal/ExpanderAnimation';
import LazyLoadImage from '../../internal/LazyLoadImage';
import deviceImg from '../../static/images/devices.png';

type BackgroundColors = 'Black' | 'Citrus' | 'White' | 'Silver' | 'Charcoal';
type Variant = 'Medium' | 'High';
type PropTypes = {|
  title: string,
  intro?: string,
  pardotFormUrl: string,
  ctaText: string,
  background: BackgroundColors,
  variant?: Variant,
|};

const backgroundMap = {
  Black: 'Dark',
  Citrus: 'Featured',
  White: 'White',
  Silver: 'Silver',
  Charcoal: 'Charcoal',
};

const SubscribeForm = (props: PropTypes) => {
  const [open, setOpen] = React.useState(false);
  const [iframeHeight, setFrameHeight] = React.useState(0);
  const onClick = () => {
    setOpen(!open);
  };

  return (
    <PageContentBlock background={backgroundMap[props.background]}>
      <div className={styles.container}>
        <h2 className={styles.title}>{props.title}</h2>
        {props.intro && <p className={styles.intro}>{props.intro}</p>}
        <ExpanderAnimation open={open} height={iframeHeight}>
          <Iframe
            src={props.pardotFormUrl}
            onResize={data => {
              setFrameHeight(data && data.height ? data.height : 0);
            }}
          />
        </ExpanderAnimation>
        {!open && (
          <Button variant={props.background === 'Black' ? 'Primary' : 'Default'} onClick={onClick}>
            {props.ctaText}
          </Button>
        )}
      </div>
      {props.variant === 'Medium' && (
        <div>
          <LazyLoadImage
            className={styles.image}
            src={deviceImg}
            alt=""
            defaultSize={{ width: 648, height: 277 }}
          />
        </div>
      )}
    </PageContentBlock>
  );
};

SubscribeForm.defaultProps = {
  background: 'Dark',
  variant: 'Medium',
};

export default SubscribeForm;
